module.exports = __webpack_public_path__ + "static/img/tagheuer_logo.efdb31c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tagheuer_logo.png
// module id = l34f
// module chunks = 1